import { useSelector } from 'react-redux';
import * as AITextService from 'services/ai/text';

export const useAITextService = () => {
  const { token } = useSelector((store) => store.user_data);

  const checkSpaminess = async (options = {}) => {
    const { payload } = await AITextService.checkSpaminess({ ...options, token });
    return payload;
  };

  return { checkSpaminess };
};
